<template>
  <div id="app">
    <router-view v-if="isRouterAlive" style="height: 100%" />
  </div>
</template>

<script>
import service from "@/CommonDP/service/login-service";
import { mapState } from "vuex";
export default {
  name: "App",
  provide() {
    return {
      reload: this.reload
    };
  },
  data() {
    return {
      isRouterAlive: true
    };
  },

  computed: {
    ...mapState({
      prjInfo: state => state.projectMg.prjObj
    })
  },

  mounted() {
    // 此处是为了实现在线人数统计 每隔十分钟就要请求一次当前用户是否在项目中
    this._timer = setInterval(() => {
      const { matched } = this.$route;
      const isInPrj = matched.some(({ name }) => name === "project");
      const params = {
        prjId: isInPrj ? this.prjInfo.prjId : "",
        clientType: "WEB端"
      };
      service
        .onlineUserSave(params)
        .then(result => {
          console.warn(params, result, "app.vue在线人数统计");
        })
        .catch(err => {
          console.log(err);
        });
    }, 600000);
  },

  destroyed() {
    clearInterval(this._timer);
  },

  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function() {
        this.isRouterAlive = true;
      });
    }
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;
  height: 100%;
  width: 100%;
}

.el-button--text {
  padding: 5px 5px;
}

.el-button [class*="el-icon-"]+span {
  margin-left: 0px;
}

.el-table--medium td,
.el-table td,
.el-table th {
  padding: 5px 0;
}

.el-table .cell {
  padding-left: 5px;
  padding-right: 5px;
}

.el-table .el-table__cell {
  padding: 5px 0;
}

.el-form--label-top .el-form-item__label {
  padding: 0px;
}

.el-form-item,
.el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
  margin-bottom: 15px;
}

/* 低代码平台的样式 */
.form-widget-container .form-widget-canvas .el-form.widget-form .el-row,
.form-widget-container .el-form.widget-form .el-row,
.form-widget-canvas .grid-container,
.form-widget-canvas .el-row,
.form-widget-canvas .el-form .el-row,
.form-widget-canvas .el-form .widget-form .el-row,
.form-widget-canvas .el-form.widget-form .el-row {
  border: 0px dashed hsla(0, 0%, 66.7%, .75);
  outline: 0px dashed #369;
}

.form-widget-canvas .el-row .grid-cell {
  outline: 0px dashed #369;
}

.el-row.grid-container,
.form-widget-canvas .grid-container,
.form-widget-canvas .el-row .grid-container {
  outline: 0px dashed #369;
}
</style>
